export default {
  firebase: {
    apiKey        : "AIzaSyA36v1naSibnquxuGvfgiojV4twnj75Qb0",
    authDomain    : "mount-forms-1b93c.firebaseapp.com",
    databaseURL   : "https://mount-forms-1b93c.firebaseio.com",
    projectId     : "mount-forms-1b93c",
    storageBucket : "mount-forms-1b93c.appspot.com",
    appId         : "1:303537874106:web:d65646cd4229bcee674e83"
  }
}